import {
  ArrowLongDownIcon,
  ArrowLongUpIcon,
  ChartCard,
  ChartNoDataFound,
  formatNumber,
  useEffect,
  useState,
} from "@";
import { useMostDonatedProjectsQuery } from "../utils/queries.js";

const MostDonatedProjects = () => {
  const [data, setData] = useState([]);
  const [searchDuration, setSearchDuration] = useState(3);

  // Use React Query to fetch most donated projects data
  const { data: projectsData } = useMostDonatedProjectsQuery(searchDuration);

  // Fetch data based on the duration
  const fetchData = (value) => {
    setSearchDuration(value);
  };

  useEffect(() => {
    if (projectsData?.mostRequestedProjects) {
      setData(projectsData.mostRequestedProjects);
    }
  }, [projectsData]);

  return (
    <>
      <ChartCard
        searchDurationUpdated={fetchData}
        title="المشاريع الاكثر تبرعا"
      >
        {data?.length > 0 ? (
          <div className="mt-5">
            {data.map((item, i) => (
              <div key={i} className="mb-4 flex items-center justify-between">
                <div className="flex items-center justify-start">
                  {/* Project image */}
                  <img
                    alt={item.projectName}
                    src={item?.projectImageFullUrl}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                  <div className="ms-2">
                    {/* Project name */}
                    <p className="text-sm font-semibold text-gray-500 dark:text-gray-400">
                      {item.projectName}
                    </p>
                    {/* Donation amount */}
                    <p className="text-xs text-gray-500">
                      {item.totalProjectDonations} ر.س
                    </p>
                  </div>
                </div>

                {/* Donation increase percentage */}
                <div
                  className={`flex items-center gap-1 text-sm ${item.raisePercentage > 0 ? "text-green-500" : "text-red-500"} `}
                >
                  {item.raisePercentage > 0 ? (
                    <ArrowLongUpIcon className="h-4 w-4" />
                  ) : (
                    <ArrowLongDownIcon className="h-4 w-4" />
                  )}
                  <span>
                    {/* render raisePercentage as positive value */}
                    {item.raisePercentage > 0
                      ? formatNumber(item.raisePercentage.toFixed(1))
                      : formatNumber((item.raisePercentage * -1).toFixed(1))}
                    %
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="h-80">
            <ChartNoDataFound />
          </div>
        )}
      </ChartCard>
    </>
  );
};

export default MostDonatedProjects;
